module.exports = __webpack_public_path__ + "img/history-even.af574375.png";